import {CheckLibs} from '@digital-supply-chain/module'
import {ApiService} from '../libs/api'
import {Category} from '../libs/category'
import {AuthService} from './auth'
import {UserService} from './user'
import {DataService} from './data'

export class AdService{

  /**
   * 获取随机广告
   * @param keyWords 
   * @param pos 
   * @param count 
   * @returns 
   */
  static getAdvert(keyWords: string = "", pos: number = 1, count: number = 1) {
    const user = AuthService.user();
    const { FixProvince, FixCity } = user;
    let url = `${ApiService.JrzzApi}/ad/adverts?count=${count}&advPos=${pos}&fixProvince=${FixProvince || ""}&fixCity=${FixCity || ""}`;
    keyWords && (url += `&keyWords=${keyWords}`);
    return DataService.get(url);
  }
  
  /**
   * 广告点击数添加
   * @param advID 
   * @returns 
   */
  static async clickAdvertAdd(advID: number) {
    // return DataService.post(`${ApiService.Common}/click/${Category.Advert}/add?dataId=${advID}`);
  }

  static getSpecialAds(filter: { q: string, treeKey: string }) {
    const { q, treeKey } = filter;
    let adsArr = [];
    function includesCheck(data: string, checkArr: string[]) {
      let check = false;
      for (let index = 0; index < checkArr.length; index++) {
        const element = checkArr[index];
        if (data.includes(element)) {
          check = true;
          break;
        }
      }
      return check;
    }

    //上海枫信传动机械有限公司 2022-12-16到期
    const fxcd = {
      "AdvID": 52583692497952,
      "AdvName": "上海枫信传动机械有限公司",
      "AdvLogo1": "//img.maidiyun.com/images/2020/08/d8796367051a4a1298ed36bf00f5404e_0x0.jpg",
      "AdvLogo2": "",
      "AdvUrl": "//80046119.maidiyun.com/category",
      "AdvContent": "伺服电机专用减速机、伺服齿轮减速机、行星齿轮减速机、精密蜗轮蜗杆减速机、精密斜齿换向器、摆线针轮减速机、齿轮减速机、蜗轮丝杆升降机、伺服电机步进电机..."
    };
    if (includesCheck(q, ["减速机", "电机", "减速器","升降机","工业齿轮箱"]) || includesCheck(`${treeKey}|`, ["|19|","|7|"])) {
      adsArr.push(fxcd);
    }

    //上海东方威尔减速机有限公司 2022-06-10到期
    const dfwr = {
      "AdvID": 45841510204448,
      "AdvName": "上海东方威尔减速机有限公司",
      "AdvLogo1": `${ApiService.OssHzHost}/jrzz/adverts/80024081.gif`,
      "AdvLogo2": "",
      "AdvUrl": "//80024081.maidiyun.com/category",
      "AdvContent": "R系列、F系列、K系列、S系列齿轮减速机，H/B系列齿轮箱，P系列行星齿轮箱"
    };
    if (includesCheck(q, ["减速机", "减速箱"]) || includesCheck(`${treeKey}|`, ["|19|"])) {
      adsArr.push(dfwr);
    }

    // 上海劲仑机械设备有限公司
    const jljx = {
      "AdvID": 45841510204449,
      "AdvName": "上海劲仑机械设备有限公司",
      "AdvLogo1": `${ApiService.OssHzHost}/jrzz/adverts/80044067.gif`,
      "AdvLogo2": "",
      "AdvUrl": "//80044067.maidiyun.com/category",
      "AdvContent": "四大系列减速机、SWL蜗轮丝杆升降机、T螺旋伞齿轮转向箱 、P行星齿轮减速机"
    };
    if (includesCheck(q, ["减速机", "电机"]) || includesCheck(`${treeKey}|`, ["|19|","|7|","|42|326|"])) {
      adsArr.push(jljx);
    }

    // 杭州艾勒维特传动机械有限公司
    const alwt = {
      "AdvID": 45841510204450,
      "AdvName": "杭州艾勒维特传动机械有限公司",
      "AdvLogo1": `${ApiService.OssHzHost}/jrzz/adverts/80034385.gif`,
      "AdvLogo2": "",
      "AdvUrl": "//80034385.maidiyun.com/category",
      "AdvContent": "蜗轮梯型丝杆升降机、蜗轮滚珠丝杆升降机、螺旋锥齿轮升降机、以及摆线及齿轮行星传动产品"
    };
    if (includesCheck(q, ["升降机"]) || includesCheck(`${treeKey}|`, ["|19|89|","|19|6056|"])) {
      adsArr.push(alwt);
    }

    //上海寅通减速机有限公司 固定广告位时间到23.9.22，会员升级金牌时间还是到23.4.15
    const shyt = {
      "AdvID": 45841520220915,
      "AdvName": "上海寅通减速机有限公司",
      "AdvLogo1": `${ApiService.OssHzHost}/jrzz/adverts/80025251.jpg`,
      "AdvLogo2": "",
      "AdvUrl": "//80025251.maidiyun.com/category",
      "AdvContent": "RV系列斜齿轮蜗轮蜗杆减速机，R系列斜齿轮减速机，K系列斜齿轮锥齿轮减速机，F系列平行轴装斜齿轮减速机，MB系列行星锥盘无级变速电机，RV系列蜗论蜗杆..."
    };
    if (includesCheck(q, ["减速机"]) || includesCheck(`${treeKey}|`, ["|19|"])) {
      adsArr.push(shyt);
    }

    //杭州上坤传动科技有限公司 2022、09、23添加
    const skcd = {
      "AdvID": 45841520220915,
      "AdvName": "杭州上坤传动科技有限公司",
      "AdvLogo1": `${ApiService.OssHzHost}/jrzz/adverts/80070623.gif`,
      "AdvLogo2": "",
      "AdvUrl": "//80070623.maidiyun.com/category",
      "AdvContent": "WPNMRV蜗轮蜗杆减速机RFKS齿轮减速机，SWL/HK丝杆升降机，MB无级变速器，T/HD转向器，摆线齿轮减速机电机等"
    };
    if (includesCheck(q, ["减速机"]) || includesCheck(`${treeKey}|`, ["|19|"])) {
      adsArr.push(skcd);
    }

    //江苏益而达科技有限公司 2022、09、27添加
    const jsyed = {
      "AdvID": 45841520220916,
      "AdvName": "江苏益而达科技有限公司",
      "AdvLogo1": `${ApiService.OssHzHost}/jrzz/adverts/80096680-1.gif`,
      "AdvLogo2": "",
      "AdvUrl": "//80096680.maidiyun.com/category",
      "AdvContent": "THK品牌直线导轨、滚珠丝杆、滚珠花键、中央平台、直线电机等"
    };
    if (includesCheck(q, ["传动件","直线导轨","工厂自动化","导轨","直线电机","丝杆","螺杆","花键","轴环","移动平台","检测设备","智能组合单元","THK"]) || includesCheck(`${treeKey}|`, ["|32|","|2872|"])) {
      adsArr.push(jsyed);
    }

    //正心机器（上海）有限公司 2022、09、30添加
    const zxjq = {
      "AdvID": 45841520220930,
      "AdvName": "正心机器（上海）有限公司",
      "AdvLogo1": `${ApiService.OssHzHost}/jrzz/adverts/80058823-1.gif`,
      "AdvLogo2": "",
      "AdvUrl": "//80058823.maidiyun.com/category",
      "AdvContent": "导轨、互换上银导轨、滑台、模组、TBI丝杆、直线导轨、模组、滚珠丝杆副、高精度研磨齿轮、齿条、直线电机、直线滑台等"
    };
    if (zxjq.AdvContent.includes(q) || includesCheck(`${treeKey}|`, ["|32|","|2872|"])) {
      adsArr.push(zxjq);
    }

    return adsArr;
  }

  /**
   * 首页banner轮播图的活动广告
   * @returns 
   */
  static home_swiper_activity() {
    let adsArr = [
      { compId: 0, img: 'join-3.jpg', name: '合作伙伴招募', advId: '001', activityId: 1 },
      // { compId: 0, img: 'BigEEInstall.jpg', name: '大工程师企业版', advId: '002', activityId: 2 },
    ];

    // if (CheckLibs.isBigEngineerE() || CheckLibs.isGreatCraftsman() || CheckLibs.isGreatCraftsmanEnt()) {
      adsArr = adsArr.filter(item => item.activityId != 1);
    // }

    let userPhone = '';
    try {
      userPhone = `${UserService.user().Phone}`;
    } catch (error) {}
    // 活动1的广告对于部分用户不展示
    const act1Filter = ['13840902959','13840902959','13387839869','13387839869','18953396669', '18909883699', '13251027363', '18906410209', '18037386667', '13911589386', '18072743592', '18962529826'];
    if (act1Filter.includes(userPhone)) {
      adsArr = adsArr.filter(item => item.activityId != 1);
      adsArr = adsArr.filter(item => item.activityId != 2);
    }


    return adsArr.map(item => ({
      ...item,
      image: `${ApiService.OssHzHost}/jrzz/home_ad/${item.img}`,
    }));
  }

  static home_swiper_ads(page = 1, size = 5) {
    const adsArr = [
      // { compId: 18313, img: '18313.jpg', name: '东莞市高工智能传动股份有限公司', advId: '184454510222245880', advTypeId: 1 },
      // { compId: 1929, img: '1929.jpg', name: '东莞市国耀铝材有限公司', advId: '184454510222245881', advTypeId: 1 },
      // { compId: 53086, img: '53086.jpg', name: '杭州龙威传动有限公司', advId: '184454510222245883', advTypeId: 1 },
      // { compId: 51507, img: '51507.jpg', name: '宁波得发科技有限公司', advId: '184454510222245884', advTypeId: 1 },
      { compId: 31773, img: '149542.gif', name: '上海锐进减速机有限公司', advId: '184454510222245886', advTypeId: 1 },
      // { compId: 1, img: '航天云网.jpg', name: '航天云网设计协同平台', advId: '184454510222245887', outUrl: 'http://changzhou.casicloud.com/view/solution/109.html' },
      // { compId: 1377, img: '1377.jpg', name: '浙江丰州精密制造有限公司', advId: '184454510222245889', advTypeId: 1 },
    ];
    const startNum = (page - 1) * size;
    return adsArr.map(item => ({
      ...item,
      targetUrl: `/company/home/${item.compId}?type=company&id=${item.compId}`,
      image: `${ApiService.OssHzHost}/jrzz/home_ad/${item.img}`,
    })).slice(startNum, startNum + size);
  }

  /**
   * 展示广告
   */
  static async viewAdverts(advs: any = []) {
    const advIds = advs.map((item: { advId: string; }) => item.advId);
    let urlParams = '';
    if (advIds.length <= 0) return
    advIds.forEach((item: string, index: number) => {
      urlParams = urlParams + `${index === 0 ? '?' : '&'}advIds=${item}`
    })
    return await DataService.post(`${ApiService.Api81}/adverts/viewAdverts${urlParams}`);
  }

  /**
   * 查询广告
   * @param type 
   * @param limit 
   * @returns 
   */
  static async queryAdverts(type: number, limit: number = 10) {
    return await DataService.get(`${ApiService.Api81}/adverts/queryAdverts?limit=${limit}&type=${type}`, {}, { interceResponse: true });
  }

  /**
   * 点击广告
   * @param advId 
   * @returns 
   */
  static async clickAdverts(advId: string) {
    return await DataService.post(`${ApiService.Api81}/adverts/clickAdverts?advId=${advId}`);
  }

}
